import { Timeline } from '@/common/components/timeline/Timeline';
import { ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { formatEventTimeDiff } from '@/features/events/components/events-timeline/utils/formatEventTimeDiff.ts';
import Box from '@mui/material/Box';
import { EventTime } from '@/features/events/components/events-timeline/subcomponents/event-time/EventTime.tsx';

export interface EventTimelineItemProps {
  eventAt: Date;
  eventUtcOffset: number;
  isLast?: boolean;
  prevEventAt?: Date;
  icon?: ReactNode;
  title: ReactNode;
  labels?: ReactNode;
  metadata?: ReactNode;
  importantEvent?: boolean;
}

export const EventTimelineItem = ({
  eventAt,
  eventUtcOffset,
  icon,
  prevEventAt,
  labels,
  metadata,
  isLast,
  title,
  importantEvent,
}: EventTimelineItemProps) => {
  return (
    <Timeline.Item
      icon={icon}
      isLast={isLast}
      leftContent={
        <EventTime eventAt={eventAt} eventUtcOffset={eventUtcOffset} horizontalAlign="end" />
      }
      lineBadge={
        prevEventAt ? (
          <Timeline.LineBadge>{formatEventTimeDiff(eventAt, prevEventAt)}</Timeline.LineBadge>
        ) : undefined
      }
      rightContent={
        <Stack pt={{ xs: 0.5, md: 2 }} gap={1}>
          <Box display={{ xs: 'block', md: 'none' }}>
            <EventTime eventAt={eventAt} eventUtcOffset={eventUtcOffset} />
          </Box>
          <Stack direction="row" flexWrap="wrap" columnGap={2} rowGap={1} alignItems="center">
            <Typography
              fontWeight={500}
              fontSize="1.2em"
              color={importantEvent ? 'textPrimary' : 'textSecondary'}
            >
              {title}
            </Typography>
            {labels}
          </Stack>
          {metadata}
        </Stack>
      }
    />
  );
};
